module.exports = __webpack_public_path__ + "static/media/jesie_serious.2f6dd6e3.png";